import React, { useRef, useState } from "react";
import { IoCheckboxSharp } from "react-icons/io5";
import { GrCheckbox } from "react-icons/gr";
import { StyledCheckboxContainer } from "./styled";
import { useOnClickOutside } from "../../helper/hooks";

interface Props {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  readonly?: boolean;
  style?: React.CSSProperties;
  messageOnHover?: string;
}

const Checkbox: React.FC<Props> = ({
  label,
  checked,
  onChange,
  disabled,
  readonly,
  style,
  messageOnHover,
}) => {
  const [message, setMessage] = useState("");
  const ref = useRef<HTMLElement>(null);
  useOnClickOutside(ref, () => {
    setMessage("");
  });
  return (
    <StyledCheckboxContainer
      style={style}
      disabled={disabled}
      readonly={readonly}
      message={message}
    >
      {checked ? (
        <IoCheckboxSharp
          onClick={() => {
            onChange(false);
          }}
        />
      ) : (
        <GrCheckbox
          onClick={() => {
            onChange(true);
          }}
        />
      )}{" "}
      <span>
        {label}
        {messageOnHover && (
          <small
            className="info"
            ref={ref}
            onClick={() => {
              setMessage(messageOnHover);
            }}
            onMouseEnter={() => {
              setMessage(messageOnHover);
            }}
            onMouseLeave={() => {
              setMessage("");
            }}
          >
            ?
          </small>
        )}
      </span>
    </StyledCheckboxContainer>
  );
};

export default Checkbox;
